export default __webpack_public_path__ + "70d82fc369394e0bd26aedddec7a0276.svg";